module.exports = __webpack_public_path__ + "img/renew.308a9728.png";